import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import NonIconButton from "../../../../components/NonIconButton";
import { recruitmentDetailContext } from "../../RecruitmentDetailPage";
import BaseApi from "../../../../functions/axios";

export default function CloseRecruitmentButton() {
  const navigate = useNavigate();
  const { reason, projectId, projectStatus } = useContext(
    recruitmentDetailContext
  );
  const [loading, setLoading] = useState(false);

  const isClosed = projectStatus === 9;
  const canClose = reason !== null && !isClosed && !loading;

  const handleCloseProject = async () => {
    if (!canClose) return;
    setLoading(true);

    try {
      const res = await BaseApi.post("close_project", {
        project_id: projectId,
        reason,
      });

      if (res?.data?.result === 0 || res?.status === 200) {
        alert("募集をクローズしました。");
        navigate("/recruitmentListPage/");
      } else {
        alert("募集のクローズに失敗しました。");
      }
    } catch (error) {
      console.error("close_project error:", error);
      alert("エラーが発生しました。");
    } finally {
      setLoading(false);
    }
  };

  if (isClosed) {
    return (
      <Box sx={{ width: "160px" }}>
        <NonIconButton disabled title="クローズ済み" />
      </Box>
    );
  }

  return (
    <Box sx={{ width: "160px" }}>
      <NonIconButton
        title="募集をクローズ"
        disabled={!canClose}
        clickEvent={handleCloseProject}
      />
    </Box>
  );
}